export default __webpack_public_path__ + "static/media/home.e9edc28a.png";